import { gql } from 'apollo-angular';

// Test Case queries — Go Lambda API
export const FDD_GET_TEST_CASE_QUERY = gql`
  query getTestCase($uid: String!) {
    getTestCase(uid: $uid) {
      Id
      Data
      LockInfo {
        LockedBy
        LockedAt
      }
    }
  }
`;

export const FDD_GET_ALL_TEST_CASES_QUERY = gql`
  query getAllTestCases($currentPage: Int!, $pageSize: Int!, $filters: [FilterInput], $scope: Scope) {
    getAllTestCases(currentPage: $currentPage, pageSize: $pageSize, filters: $filters, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

// Test Suite queries — Go Lambda API
export const FDD_GET_TEST_SUITE_QUERY = gql`
  query getTestSuite($uid: String!) {
    getTestSuite(uid: $uid) {
      Id
      Data
      LockInfo {
        LockedBy
        LockedAt
      }
    }
  }
`;

export const FDD_GET_ALL_TEST_SUITES_QUERY = gql`
  query getAllTestSuites($currentPage: Int!, $pageSize: Int!, $filters: [FilterInput], $scope: Scope) {
    getAllTestSuites(currentPage: $currentPage, pageSize: $pageSize, filters: $filters, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

// Search queries — Go Lambda API
export const FDD_SEARCH_TEST_CASES_QUERY = gql`
  query searchTestCases($testCase: String!, $currentPage: Int!, $pageSize: Int!, $scope: Scope) {
    searchTestCases(testCase: $testCase, currentPage: $currentPage, pageSize: $pageSize, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

export const FDD_SEARCH_TEST_SUITES_QUERY = gql`
  query searchTestSuites($testSuite: String!, $currentPage: Int!, $pageSize: Int!, $scope: Scope) {
    searchTestSuites(testSuite: $testSuite, currentPage: $currentPage, pageSize: $pageSize, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

export const FDD_SEARCH_TEST_ANALYSES_QUERY = gql`
  query searchTestAnalyses($testAnalysis: String!, $currentPage: Int!, $pageSize: Int!, $scope: Scope) {
    searchTestAnalyses(testAnalysis: $testAnalysis, currentPage: $currentPage, pageSize: $pageSize, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

// Test Analysis queries — Go Lambda API
export const FDD_GET_TEST_ANALYSIS_QUERY = gql`
  query getTestAnalysis($uid: String!) {
    getTestAnalysis(uid: $uid) {
      Id
      Data
      LockInfo {
        LockedBy
        LockedAt
      }
    }
  }
`;

export const FDD_GET_ALL_TEST_ANALYSES_QUERY = gql`
  query getAllTestAnalyses($currentPage: Int!, $pageSize: Int!, $filters: [FilterInput], $scope: Scope) {
    getAllTestAnalyses(currentPage: $currentPage, pageSize: $pageSize, filters: $filters, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

// Test Specification queries — Go Lambda API
export const FDD_GET_TEST_SPECIFICATION_QUERY = gql`
  query getTestSpecification($uid: String!) {
    getTestSpecification(uid: $uid) {
      Id
      Data
      LockInfo {
        LockedBy
        LockedAt
      }
    }
  }
`;

export const FDD_GET_ALL_TEST_SPECIFICATIONS_QUERY = gql`
  query getAllTestSpecifications($currentPage: Int!, $pageSize: Int!, $filters: [FilterInput], $scope: Scope) {
    getAllTestSpecifications(currentPage: $currentPage, pageSize: $pageSize, filters: $filters, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

export const FDD_SEARCH_TEST_SPECIFICATIONS_QUERY = gql`
  query searchTestSpecifications($testSpecification: String!, $currentPage: Int!, $pageSize: Int!, $scope: Scope) {
    searchTestSpecifications(testSpecification: $testSpecification, currentPage: $currentPage, pageSize: $pageSize, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

// ---------------------------------------------------------------------------
// EESE coverage ENTITY (eesecoverage-lambda). Same { Id, Data, LockInfo } JSON-string
// shape as the four test-item entities — not to be confused with
// FDD_EESE_COVERAGE_EVALUATION_QUERY below, which is the typed evaluation read.
// ---------------------------------------------------------------------------

export const FDD_GET_EESE_COVERAGE_QUERY = gql`
  query getEeseCoverage($uid: String!) {
    getEeseCoverage(uid: $uid) {
      Id
      Data
      LockInfo {
        LockedBy
        LockedAt
      }
    }
  }
`;

// `scope` is accepted for symmetry with the other entities, but only ALL and MINE are
// meaningful: nothing populates functionalGroupOwners on an EESE coverage item, so
// MY_GROUP always resolves to an empty page. See eesecoverage-lambda/README.md.
export const FDD_GET_ALL_EESE_COVERAGES_QUERY = gql`
  query getAllEeseCoverages($currentPage: Int!, $pageSize: Int!, $filters: [FilterInput], $scope: Scope) {
    getAllEeseCoverages(currentPage: $currentPage, pageSize: $pageSize, filters: $filters, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

export const FDD_SEARCH_EESE_COVERAGES_QUERY = gql`
  query searchEeseCoverages($eeseCoverage: String!, $currentPage: Int!, $pageSize: Int!, $scope: Scope) {
    searchEeseCoverages(eeseCoverage: $eeseCoverage, currentPage: $currentPage, pageSize: $pageSize, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

// ---------------------------------------------------------------------------
// Software version coverage ENTITY (softwareversioncoverage-lambda). Same
// { Id, Data, LockInfo } JSON-string shape as EESE coverage — not to be confused with
// FDD_SW_VERSION_COVERAGE_EVALUATION_QUERY below, which is the typed evaluation read.
// Data carries ecuIds / softwareVersions as string arrays (the Go field is `ecuIds`,
// NOT the `ecus` the test-case lambda uses).
// ---------------------------------------------------------------------------

export const FDD_GET_SW_VERSION_COVERAGE_QUERY = gql`
  query getSoftwareVersionCoverage($uid: String!) {
    getSoftwareVersionCoverage(uid: $uid) {
      Id
      Data
      LockInfo {
        LockedBy
        LockedAt
      }
    }
  }
`;

// Only ALL and MINE are meaningful, as for EESE coverage: nothing populates
// functionalGroupOwners on this item, so MY_GROUP always resolves to an empty page.
export const FDD_GET_ALL_SW_VERSION_COVERAGES_QUERY = gql`
  query getAllSoftwareVersionCoverages($currentPage: Int!, $pageSize: Int!, $filters: [FilterInput], $scope: Scope) {
    getAllSoftwareVersionCoverages(currentPage: $currentPage, pageSize: $pageSize, filters: $filters, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

// ---------------------------------------------------------------------------
// Specification coverage ENTITY (specificationcoverage-lambda). Same
// { Id, Data, LockInfo } JSON-string shape as the other two coverage entities — not
// to be confused with FDD_SPECIFICATION_COVERAGE_EVALUATION_QUERY, which is the typed
// evaluation read. Data carries specifications[] / requirements[], each keyed on
// (polarionId, irmaVersion).
// ---------------------------------------------------------------------------

export const FDD_GET_SPEC_COVERAGE_QUERY = gql`
  query getSpecificationCoverage($uid: String!) {
    getSpecificationCoverage(uid: $uid) {
      Id
      Data
      LockInfo {
        LockedBy
        LockedAt
      }
    }
  }
`;

// Only ALL and MINE are meaningful, as for the other coverage entities: nothing
// populates functionalGroupOwners on this item, so MY_GROUP resolves to an empty page.
export const FDD_GET_ALL_SPEC_COVERAGES_QUERY = gql`
  query getAllSpecificationCoverages($currentPage: Int!, $pageSize: Int!, $filters: [FilterInput], $scope: Scope) {
    getAllSpecificationCoverages(currentPage: $currentPage, pageSize: $pageSize, filters: $filters, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

export const FDD_SEARCH_SPEC_COVERAGES_QUERY = gql`
  query searchSpecificationCoverages($specificationCoverage: String!, $currentPage: Int!, $pageSize: Int!, $scope: Scope) {
    searchSpecificationCoverages(specificationCoverage: $specificationCoverage, currentPage: $currentPage, pageSize: $pageSize, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

export const FDD_SEARCH_SW_VERSION_COVERAGES_QUERY = gql`
  query searchSoftwareVersionCoverages($softwareVersionCoverage: String!, $currentPage: Int!, $pageSize: Int!, $scope: Scope) {
    searchSoftwareVersionCoverages(softwareVersionCoverage: $softwareVersionCoverage, currentPage: $currentPage, pageSize: $pageSize, scope: $scope) {
      Items {
        Id
        Data
        LockInfo {
          LockedBy
          LockedAt
        }
      }
      TotalCount
      CurrentPage
      PageSize
      TotalPages
    }
  }
`;

// ---------------------------------------------------------------------------
// Coverage evaluation (specificationcoverage- / eesecoverage- /
// softwareversioncoverage-lambda).
//
// These do not follow the `{ Id, Data }` JSON-string shape the entity lambdas
// use: the coverage lambdas return typed camelCase objects, so the response
// needs no JSON.parse and maps almost one-to-one onto the existing DTOs.
//
// Type names are prefixed per lambda because the gateway is shared and the C#
// schema already owns EvaluationRequirement / EvaluationTestAnalysis /
// EvaluationTestCase.
// ---------------------------------------------------------------------------

export const FDD_SPECIFICATION_COVERAGE_EVALUATION_QUERY = gql`
  query getSpecificationCoverageEvaluation($requirements: [SpecificationCoverageRequirementInput!]!) {
    getSpecificationCoverageEvaluation(requirements: $requirements) {
      requirements {
        polarionId
        irmaVersion
        revision
        testAnalyses {
          uid
          name
          itemNo
          version
          latestLinkedRequirementVersion
          testCases {
            uid
            name
            itemNo
            version
            results
          }
        }
      }
    }
  }
`;

export const FDD_EESE_COVERAGE_EVALUATION_QUERY = gql`
  query getEeseCoverageEvaluation($requirements: [EeseCoverageRequirementInput!]!) {
    getEeseCoverageEvaluation(requirements: $requirements) {
      requirements {
        id
        name
        revision
        testAnalyses {
          uid
          name
          itemNo
          version
          latestLinkedRequirementVersion
          testCases {
            uid
            name
            itemNo
            version
            results
          }
        }
      }
    }
  }
`;

export const FDD_SW_VERSION_COVERAGE_EVALUATION_QUERY = gql`
  query getSoftwareVersionCoverageEvaluation($ecuId: String!, $softwareVersions: [String!]!) {
    getSoftwareVersionCoverageEvaluation(ecuId: $ecuId, softwareVersions: $softwareVersions) {
      requirements {
        polarionId
        name
        irmaVersion
        revision
        specification {
          polarionId
          name
          irmaVersion
          revision
        }
        testAnalyses {
          uid
          name
          itemNo
          version
          latestLinkedRequirementVersion
          testCases {
            uid
            name
            itemNo
            version
            results
          }
        }
      }
    }
  }
`;
